import React, {useEffect, useState} from 'react';
import Api from "../Api.js";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {notificationRequest} from "../store/actions/notification.js";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

function NotificationModal(props) {
    const [dayoff, setDayoff] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [notify, setNotify] = useState([]);
    const [survey, setSurvey] = useState([]);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector((state) => state.notification.notifyData);
    const status = useSelector((state) => state.notification.notifyDataStatus);
    useEffect(() => {
        const taskNotify = data.filter(item => item.notification.task !== null);
        const dayoffNotify = data.filter(item => item.notification.dayoff !== null);
        const notifyNotify = data.filter(item => item.notification.notification !== null);
        const surveyNotify = data.filter(item => item.notification.survey !== null);
        setTasks(taskNotify);
        setDayoff(dayoffNotify);
        setNotify(notifyNotify);
        setSurvey(surveyNotify);
    }, [data])


    const handleSeen = async (id, task, type) => {
        try {
            await Api.updateNotify(+id)
            await dispatch(notificationRequest())
            if (type === 'task') {
                navigate(`/main_employee/tasks/${task}`)
            } else if (type === 'dayoff') {
                navigate(`/main_employee/day_off?id=${task}`)
            } else if (type === 'survey') {
                navigate(`/main_employee/surveys/${task}`)
            } else {
                navigate(`/main_employee/notification`)
            }
        } catch (e) {
            console.log(e)
        }
    }
    const handleSeenAll = async (type,ev) => {
        try {
            ev.stopPropagation()
            await Api.setSeenAll(type)
            await dispatch(notificationRequest())
        } catch (e) {
        }
    }
    return (
        <div>
            <div className="notify-dropdown">
                <div className=" green-top modal-header notify-dropdown-header">
                    Հաղորդագրություններ
                </div>
                <div>
                    <div>
                        <div className="notify-title green-top align-items-center tool-tip-cont m-0">
                            <span>DayOff Հաղորդագրություններ</span>
                            <span className="tool-tip" style={{right: 0}}>Նշել դիտված</span>
                            <span className='company-name'><RemoveRedEyeIcon
                                onClick={(ev) => handleSeenAll('dayoff',ev)}/></span>
                        </div>

                        <hr className="m-0"/>
                        {status === 'request' ? <div className="notify-title">Loading...</div> : null}
                        {dayoff.map((item, index) => (
                            <div key={index} className="notify-item">
                                <span
                                    className="notify-item-side time">{moment(item.notification.created_at).format('HH:mm DD/MM/YYYY')}</span>
                                <span>{item.notification.message}</span>
                                <span className="notify-item-side more"
                                      onClick={() => handleSeen(item.id, item.notification.dayoff.id, 'dayoff')}>Իմանալ ավելին</span>
                            </div>
                        ))}
                        {dayoff.length === 0 && status !== 'request' ?
                            <div className="notify-title">Հաղորդագրություններ չկան</div> : null}
                        <hr className="m-0"/>
                        <div className="notify-title green-top align-items-center tool-tip-cont m-0">
                            <span>Առաջադրանքներ Հաղորդագրություններ</span>
                            <span className="tool-tip" style={{right: 0}}>Նշել դիտված</span>
                            <span className='company-name'><RemoveRedEyeIcon
                                onClick={(ev) => handleSeenAll('task',ev)}/></span>
                        </div>
                        <hr className="m-0"/>
                        {status === 'request' ? <div className="notify-title">Loading...</div> : null}

                        {tasks.map((item, index) => {
                            return (
                                <div key={index} className="notify-item">
                                    <span
                                        className="notify-item-side time">{moment(item.notification.created_at).format('HH:mm DD/MM/YYYY')}</span>
                                    <span>{item.notification.message}</span>
                                    <span className="notify-item-side more"
                                          onClick={() => handleSeen(item.id, item.notification.task.id, 'task')}>
                                <span>{item?.notification?.task?.creator?.first_name} {item?.notification?.task?.creator?.last_name}</span>
                                <span>Իմանալ ավելին</span>
                            </span>
                                </div>
                            )
                        })}
                        {tasks.length === 0 && status !== 'request' ?
                            <div className="notify-title">Հաղորդագրություններ չկան</div> : null}

                        <div className="notify-title green-top align-items-center tool-tip-cont m-0">
                            <span>Ծանուցումներ</span>
                            <span className="tool-tip" style={{right: 0}}>Նշել դիտված</span>
                            <span className='company-name'><RemoveRedEyeIcon
                                onClick={(ev) => handleSeenAll('notification',ev)}/></span>
                        </div>
                        <hr className="m-0"/>
                        {status === 'request' ? <div className="notify-title">Loading...</div> : null}

                        {notify.map((item, index) => (
                            <div key={index} className="notify-item">
                                <span
                                    className="notify-item-side time">{moment(item.notification.created_at).format('HH:mm DD/MM/YYYY')}</span>
                                <span>{item.notification.message}</span>
                                <span className="notify-item-side more"
                                      onClick={() => handleSeen(item.id, item.notification.notification.id, 'notification')}>Իմանալ ավելին</span>
                            </div>
                        ))}
                        {notify.length === 0 && status !== 'request' ?
                            <div className="notify-title">Հաղորդագրություններ չկան</div> : null}

                        <div className="notify-title green-top align-items-center tool-tip-cont m-0">
                            <span>Հարցումներ</span>
                            <span className="tool-tip" style={{right: 0}}>Նշել դիտված</span>
                            <span className='company-name'><RemoveRedEyeIcon
                                onClick={(ev) => handleSeenAll('survey',ev)}/></span>
                        </div>
                        {status === 'request' ? <div className="notify-title">Loading...</div> : null}

                        {survey.map((item, index) => (
                            <div key={index} className="notify-item">
                                <span
                                    className="notify-item-side time">{moment(item.notification.created_at).format('HH:mm DD/MM/YYYY')}</span>
                                <span>{item.notification.message}</span>
                                <span className="notify-item-side more"
                                      onClick={() => handleSeen(item.id, item.notification.survey.id, 'survey')}>Իմանալ ավելին</span>
                            </div>
                        ))}
                        {survey.length === 0 && status !== 'request' ?
                            <div className="notify-title">Հարցումներ չկան</div> : null}

                    </div>

                </div>
            </div>
        </div>

    );
}

export default NotificationModal;